// extracted by mini-css-extract-plugin
export default {"slider":"slider-b0Oy0","carouselContainer":"carouselContainer-vZDfK","landingSports":"landingSports-SxWyy","section-sports-calgarystampede":"section-sports-calgarystampede-P_Hm7"};